<template>
  <div class="az-form-content">
    <div>
      <div class="li-tabela">
        <v-data-table
            :headers="headersTabelaParticipantes"
            :total-items="totalItens"
            :items="itens"
            :pagination.sync="paginacaoInterna"
            no-data-text="Nenhuma Solicitação encontrada"
            :loading="false"
            hide-actions class="az-table-list"
        >
          <template slot="items" slot-scope="props">
            <td>
              {{ props.item.classificacao ? props.item.classificacao : '--' }}
            </td>
            <td>
              <div class="participante">
                <v-icon v-if="props.item.fornecedor.fornecedor" class="participante_icon">
                  person
                </v-icon>
                <p>
                  <strong>{{ props.item.fornecedor.razaoSocial }}</strong><br>
                  {{ formatarIdentificacao(props.item.fornecedor) }}
                </p>
              </div>

            </td>
            <td>
              <span v-if="props.item.dataInteresse">{{ props.item.dataInteresse | az-date('DD/MM/YYYY HH:mm:ss') }}</span>
              <span v-else>-- / -- / --</span>
            </td>
            <td>
              <span v-if="props.item.dataCredenciamento">{{ props.item.dataCredenciamento | az-date('DD/MM/YYYY HH:mm:ss') }}</span>
              <span v-else>-- / -- / --</span>
            </td>
            <td>
              <span :class="{credenciado: props.item.situacao === 'CREDENCIADO'}">{{ props.item.situacao | filtroSituacaoAnaliseCredenciamento }}</span>
            </td>

            <td>
              <a v-if="isSolicitacaoComAcaoBaixarTermoHabilitada(props.item)"
                 :href="criarLinkDownload(props.item.uriTermoCredenciamento)" target="_blank"
                 class="az-action-link-icon">
                <v-icon>get_app</v-icon>
              </a>

              <v-tooltip v-if="props.item.situacao === 'NAO_CREDENCIADO' && props.item.fornecedor.fornecedor" top>
                <a slot="activator">
                  <v-icon @click="abrirModalMotivoNaoCredenciarSolicitacaoCredenciamento(props.item)">
                    visibility
                  </v-icon>
                </a>
                <span>Ver Motivo</span>
              </v-tooltip>
              <v-tooltip top v-if="isSolicitacaoComAcaoSolicitarAssinaturaHabilitada(props.item)">
                <a slot="activator" @click="assinarDocumento(props.item)" class="px-1" style="cursor: pointer;">
                  <icone-assinar-documento/>
                </a>
                <span>Assinar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <div class="az-pagination">
          <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
          <div class="az-select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
          </div>
        </div>

      </div>
    </div>

    <modal-ver-motivo-nao-credenciamento
        v-if="isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada && modalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada"
        v-model="modalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada"
        titulo="Motivo Não Credenciamento"
        :motivo="motivoNaoCredenciarSolicitacaoCredenciamentoSelecionada"
        @fecharModalNaoCredenciamento="tratarEventoFecharModalMotivoNaoCredenciarSolicitacaoCredenciamento">
    </modal-ver-motivo-nao-credenciamento>

    <modal-selecao-tipo-assinatura
        :exibir="exibirModalSelecaoTipoAssinatura"
        :idLicitacao="licitacao.id"
        :titulo="'Selecionar Tipo de Assinatura'"
        :documentos="documentosParaAssinar"
        @fechar-modal="fecharModalSelecaoTipoAssinatura"
        @resetar-documentos="resetarDocumentosParaAssinar">
    </modal-selecao-tipo-assinatura>
  </div>
</template>

<script>

import SituacaoPill from '@/views/credenciamento/detalhe-credenciamento/commons/SituacaoPill.vue'
import {mapState} from 'vuex'
import ModalVerMotivoNaoCredenciamento
  from '@/views/credenciamento/detalhe-credenciamento/commons/ModalVerMotivoNaoCredenciamento.vue'
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento.vue";
import ModalSelecaoTipoAssinatura from '@/views/credenciamento/detalhe-credenciamento/assinaturas/selecao-tipo-assinatura/ModalSelecaoTipoAssinatura.vue';

function extrairNumeracao(cpfCnpj) {
  return cpfCnpj.replace(/\D/g, '');
}

export default {
  name: 'ListagemResultado',
  components: {IconeAssinarDocumento, ModalVerMotivoNaoCredenciamento, SituacaoPill, ModalSelecaoTipoAssinatura},
  props: ['itens', 'paginacao', 'paginas', 'totalItens'],
  data() {
    return {
      paginacaoInterna: this.paginacao,
      linhasPorPagina: [10, 25, 50, 100],
      isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada: false,
      modalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada: false,
      motivoNaoCredenciarSolicitacaoCredenciamentoSelecionada: null,
      exibirModalSelecaoTipoAssinatura: false,
      documentosParaAssinar: [],
      itemSelecionadoParaAssinatura: null
    }
  },
  computed: {
    ...mapState(['licitacao']),
    headersTabelaParticipantes() {
      const headers = [
        {
          text: 'Classificação',
          align: 'left',
          sortable: false,
          value: 'classificacaoDefinitiva',
          class: 'primary--text',
          width: '10px'
        },
        {
          text: 'Participante',
          align: 'left',
          sortable: false,
          width: '500px',
          value: 'fornecedor.razaoSocial',
          class: 'primary--text'

        },
        {
          text: 'Data Interesse',
          value: 'dataInteresse',
          sortable: false,
          align: 'left',
          width: '30px',
          class: 'primary--text'
        },
        {
          text: 'Data Credenciamento',
          value: 'dataCredenciamento',
          sortable: false,
          align: 'left',
          width: '30px',
          class: 'primary--text'
        },
        {
          text: 'Situação',
          value: 'situacao',
          sortable: false,
          align: 'left',
          width: '100px',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          value: 'situacao',
          sortable: false,
          align: 'left',
          class: 'primary--text',
          width: '10px'
        }
      ];
      return headers.filter(header => header.visible !== false);
    }
  },
  methods: {
    formatarIdentificacao(item) {
      const identificacao = item.cpfCnpj;
      const tipo = item.tipoPessoa;

      if (tipo === 'F') {
        return this.formatarCPF(identificacao);
      } else if (tipo === 'J') {
        return this.formatarCNPJ(identificacao);
      }
      return identificacao;
    },
    formatarCPF(cpf) {
      cpf = extrairNumeracao(cpf);
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
    formatarCNPJ(cnpj) {
      if (!cnpj) return '';

      const cnpjLimpo = cnpj.replace(/[.\-/]/g, '');

      if (cnpjLimpo.length === 14) {
        if (/^\d{14}$/.test(cnpjLimpo)) {
          return cnpjLimpo.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else if (/^[\w\d]{14}$/.test(cnpjLimpo)) {
          return cnpjLimpo.replace(/([\w\d]{2})([\w\d]{3})([\w\d]{3})([\w\d]{4})([\w\d]{2})/, '$1.$2.$3/$4-$5');
        }
      }

      return cnpj;
    },
    isSolicitacaoComAcaoBaixarTermoHabilitada(solicitacaoCredenciamento) {
      return solicitacaoCredenciamento.situacao === 'CREDENCIADO' &&
          !!solicitacaoCredenciamento.analiseSolicitacaoCredenciamento
    },
    abrirModalMotivoNaoCredenciarSolicitacaoCredenciamento(solicitacaoCredenciamento) {
      this.motivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = solicitacaoCredenciamento.motivoNaoCredenciamento
      this.isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = true
      this.modalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = true
    },
    tratarEventoFecharModalMotivoNaoCredenciarSolicitacaoCredenciamento() {
      this.isMostrarModalMotivoNaoCredenciarSolicitacaoCredenciamentoSelecionada = false
    },
    isSolicitacaoComAcaoSolicitarAssinaturaHabilitada(item) {
      // eslint-disable-next-line
      console.log(item)
      return item.idVirtualizado && item.situacao === 'CREDENCIADO' && item.assinaturaSolicitada && !item.assinado && item.fornecedor.fornecedor
    },
    async assinarDocumento(item) {
      this.itemSelecionadoParaAssinatura = item;
      this.documentosParaAssinar = [item];
      this.exibirModalSelecaoTipoAssinatura = true;
    },
    fecharModalSelecaoTipoAssinatura() {
      this.exibirModalSelecaoTipoAssinatura = false;
      this.itemSelecionadoParaAssinatura = null;
      this.documentosParaAssinar = [];
    },
    resetarDocumentosParaAssinar() {
      this.documentosParaAssinar = [];
      this.$emit('buscar-solicitacoes');
    },
  },
  watch: {
    paginacaoInterna: {
      handler(novoValor) {
        this.$emit('paginar', novoValor)
      },
      deep: true,
    },
  }
}
</script>
<style scoped lang="stylus">
.background-pill
  color white
  font-weight bold
  padding 5px
  background #9191918a
  border-radius calc(20px / 2)
  white-space nowrap
  margin 0 2rem

.custom-select .v-select__slot
  border 1px solid #9191918a !important
  border-radius 4px !important
  padding 4px 8px !important

.custom-select .v-input__append-inner
  margin-right -8px

.credenciado
  color #51a806
.participante
  display flex
  align-items center

.participante_icon
  margin-right 10px
  color #0067a5 !important
  position relative
  top -7px

</style>
